module.exports = __webpack_public_path__ + "static/media/email_icon.ede5363a.png";